import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { GetAppropriatenessClientUseCase, GetClientUseCase, GetSelectedProductsUseCase } from '../../../../core';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { Id } from '../../../domain/data';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';
import { RepeatTestPage } from '../repeat-test.page';
import { TestResultPage } from '../../test/result/test-result.page';

@Component({
    templateUrl: './repeat-test-result.page.html',
    styleUrls: ['../../test/result/test-result.page.scss'],
})
export class RepeatTestResultPage extends TestResultPage implements OnInit {
    constructor(
        parentEvents: ParentEvents,
        repeatTestPage: RepeatTestPage,
        dialog: MatDialog,
        getAppropriatenessClientUseCase: GetAppropriatenessClientUseCase,
        getSelectedProductsUseCase: GetSelectedProductsUseCase,
        localStorage: LocalStorage,
        route: ActivatedRoute,
        router: Router,
        private getClientUseCase: GetClientUseCase
    ) {
        super(
            parentEvents,
            repeatTestPage,
            dialog,
            getAppropriatenessClientUseCase,
            getSelectedProductsUseCase,
            localStorage,
            route,
            router
        );
    }

    ngOnInit() {
        this.getProfileName();

        this.route.queryParams.subscribe((params) => {
            this.isSuitability = params.suitability === '1';
        });
    }

    protected getProfileName() {
        if (this.localStorage.clientCode) {
            this.getClientUseCase.bind({ code: Id.fromString(this.localStorage.clientCode) }).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.profileName = transaction.data.mifidCompetenceName;
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog, {
                        data: { text: transaction.error },
                    });
                }
            });
        } else {
            this.parentEvents.cancel();
        }
    }

    onClick() {
        if (this.isSuitability) {
            this.router.navigateByUrl(MainRoutes.REPEAT_TEST_RESULT_SUITABILITY);
        } else {
            this.router.navigateByUrl(MainRoutes.REPEAT_TEST_SIGN);
        }
    }
}
